import 'core-js/stable';

import '@libs-uuif/assets/scss/uuif.scss';
import './assets/scss/main.scss';

import Vue from 'vue';

import { i18nService } from '@libs-uuif/shared/i18n-service';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';

import VueFormulate from '@braid/vue-formulate';
import '../node_modules/@braid/vue-formulate/dist/snow.min.css';

import Bootstrap from './bootstrap.vue';
import router from './router';
import store from './store';
import ApiServiceWrapper from '@/shared/api-request.service';
import AutoComplete from 'primevue/autocomplete';
import Vuelidate from 'vuelidate';
import { navService } from '@/app-shared/nav-service';
import IdleVue from 'idle-vue';
// import vueCustomElement from 'vue-custom-element';

// Vue.use(vueCustomElement);
// const bootstrap = new Bootstrap().$options;
// bootstrap.router = router;
// bootstrap.store = store;
// bootstrap.i18n = i18nService.i18n;
// Vue.customElement('msw-workspace', bootstrap);
const eventsHub = new Vue();

Vue.use(IdleVue, {
  store,
  eventEmitter: eventsHub,
  idleTime: 30000,
  startAtIdle: false,
});
Vue.directive('tooltip', tooltip);
Vue.component('AutoComplete', AutoComplete);
Vue.use(Vuelidate);

ApiServiceWrapper.init(router, store);
navService.initNavId(router, store);

new Vue({
  router,
  store,
  i18n: i18nService.i18n,
  el: '#app',
  render: h => h(Bootstrap),
});

Vue.use(VueFormulate);
